export default __webpack_public_path__ + "static/media/hht2_sitcom_09.0d87be84.png";